<template>
    <modal :show.sync=show :hidefooter="true">
        <h3 slot="header" class="mb-0 font-weight-500">Switch Fund</h3>
        <b-row>
            <b-col cols="auto">
                <p class="text-muted text-xs">Contribution Amount</p>
                <p class="font-weight-600">RM {{ 64000 | moneyFormatter }}</p>
            </b-col>
            <b-col cols="auto">
                <p class="text-muted text-xs">Release Term</p>
                <p class="font-weight-600">24 months</p>
            </b-col>
        </b-row>
        <p class="text-xs mt-4">Select Fund Plan</p>
        <div class="border pt-3">
            <b-card-group>
                <b-col 
                    cols="12"
                    md="6"
                    class="px-2"
                    v-for="(card, index) in cards" :key="index"
                >
                    <b-card no-body class="p-2 cursor-pointer" :class="{ 'bg-primary': card.selected }">
                        <h4 :class="{ 'text-white': card.selected }">{{ card.name }}</h4>
                        <p :class="{ 'text-white': card.selected }" class="text-xs text-muted">Release Condition</p>
                        <p :class="{ 'text-white': card.selected }" class="text-xs">{{ card.release_cond }}</p>
                        <p :class="{ 'text-white': card.selected }" class="text-xs text-muted">Profit (p.a)</p>
                        <p :class="{ 'text-white': card.selected }" class="text-xs">{{ card.profit }}%</p>
                    </b-card>
                </b-col>
            </b-card-group>
        </div>
        <b-col cols="12" class="text-center">
            <el-button type="primary" class="w-50">Switch</el-button>
        </b-col>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Button } from 'element-ui'

export default {
    props: {
        switch_fund: Boolean
    },
    components: {
        Modal,
        [Button.name]: Button,
    },
    data() {
        return {
            cards: [
                {
                    name: 'JV Fund 1.0-15%',
                    release_cond: 'Half Yearly',
                    profit: '15%',
                    selected: false
                },
                {
                    name: 'JV Fund 1.0-12%',
                    release_cond: 'Half Yearly',
                    profit: '12%',
                    selected: true
                },
                {
                    name: 'JV Fund 1.0-7.5%',
                    release_cond: 'Half Yearly',
                    profit: '7.5%',
                    selected: false
                },
                {
                    name: 'JV Fund 1.0-6%',
                    release_cond: 'Half Yearly',
                    profit: '6%',
                    selected: false
                },
                {
                    name: 'Raya - 15%',
                    release_cond: 'Monthly',
                    profit: '15%',
                    selected: false
                },
                {
                    name: 'Malaysia Day - 15%',
                    release_cond: 'Monthly',
                    profit: '15%',
                    selected: false
                },
                {
                    name: 'JV Fund 3.0 - 15%',
                    release_cond: 'Monthly',
                    profit: '15%',
                    selected: false
                },
                {
                    name: 'JV Fund 3.0 - 12%',
                    release_cond: 'Monthly',
                    profit: '12%',
                    selected: false
                },
                {
                    name: 'Special Plan - 15%',
                    release_cond: 'Monthly',
                    profit: '15%',
                    selected: false
                },
                {
                    name: 'Short Term - 5%',
                    release_cond: 'Monthly',
                    profit: '5%',
                    selected: false
                },
            ]
        }
    },
    computed: {
        show: {
            get() {
                return this.switch_fund;
            },
            set(newVal) {
                this.$emit('update:switch_fund', newVal);
            },
        },
    },
}
</script>